<template>
  <div
    class="cxm-CardContent"
    :class="{ 'cxm-CardContent-Shadow': shadow, 'cxm-CardContent-CursorPointer': showCursorPointer }"
    v-on="handleClick ? { click: handleClick } : {}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'CardContent',
  props: {
    shadow: {
      type: Boolean,
      default: false,
    },
    cursorPointer: {
      type: Boolean,
      default: false,
    },
    handleClick: {
      type: Function,
      default: () => { },
    },
  },
  computed: {
    showCursorPointer() {
      if (this.cursorPointer === false) {
        return false;
      }
      return this.cursorPointer || this.handleClick;
    },
  },
};
</script>
<style lang="scss" scoped>
.cxm-CardContent {
  background: var(--track-color-white);
  border-radius: var(--track-border-radius-sm);
  padding: var(--track-spacing-bg);
  color: var(--track-color-bluegray-70);

  & + & {
    margin-top: var(--track-spacing-bg);
  }
}
.cxm-CardContent-Shadow {
  box-shadow: var(--track-shadow-sm);
}
.cxm-CardContent-CursorPointer {
  cursor: pointer;
}
</style>
